<template>
    <div class="container-fluid position-relative bg-BAT">
        <div v-if="combinedData === null">
            <loading></loading>
        </div>
        <div v-else>
            <div class="container watch-container py-4">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt="" />
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread"
                               href="/home-bat">Staff</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" href="/home-bat"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>

            <div class="container mt-3">
                <div>
                    <div class="col-12 col-md-6">
                        <div class="header-portfolio d-flex flex-column">
                            <h5 class="text-title-bat mb-2">Staff</h5>
                        </div>
                        <el-alert v-if="showAlert && admin_staff_segments.includes(client_segment)" class="custom-alert" title="Una vez aprobada tu solicitud, tu nuevo usuario staff se activará proximamente." type="warning" show-icon style="position: fixed; top: 107px; right: 8%; z-index: 2000; border: 1px solid #FFBA01; background-color: #FEFFE3; border-radius: 8px;">
                        </el-alert>
                    </div>
                    <div class="row">
<!--                        <div class="col-12 col-md-6 col-lg-6 col-xl-6 order-2 order-md-0">-->
<!--                            <a v-if="admin_staff_segments.includes(client_segment)" href="#" @click="handleRedirect" class="text-decoration-none">-->
<!--                                <button :disabled="isButtonDisabled" :class="{'btn-disabled-staff': isButtonDisabled, 'btn': true, 'rounded-3': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btnBlue': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"-->
<!--                                >Vincular usuario staff <span class="ms-2"> +</span> </button>-->
<!--                            </a>-->
<!--                        </div>-->
                        <div v-if="admin_staff_segments.includes(client_segment)" class="col-12 col-md-12 order-3 order-md-6 order-lg-4">
                            <el-alert
                                type="warning"
                                :closable="false"
                                class="custom-alert-staff-no-quotas"
                                show-icon
                                v-if="isButtonDisabled"
                            >
                                <div class="text-bat">
                                    <strong>Tienes un número máximo de usuarios, </strong>
                                    por ahora no podrás crear uno nuevo.
                                </div>
                            </el-alert>
                        </div>
                        <div v-if="admin_staff_segments.includes(client_segment)" class="col-12 col-md-6 col-lg-6 col-xl-6 order-0 order-md-1 order-lg-1 container-dropdown-pdv">
                            <div class="filter-month-staff">
                                <div class="custom-select" ref="customSelect" @click="toggleDropdown" :class="{ open: isOpen }">
                                    <div v-if="!isOpen" class="selected-option" @click="toggleDropdown">
                                        <div class="pdv-name" @click="toggleDropdown">
                                            {{ selectedPdvObj ? truncateText(selectedPdvObj.name_pdv, 35) : 'Selecciona un PDV' }}
                                        </div>
                                        <div class="pdv-address" v-if="selectedPdvObj" @click="toggleDropdown">
                                            <img src="/img-version2/icons/staff/location.svg" alt="location">
                                            {{ truncateText(selectedPdvObj.address_pdv, 35) }}
                                        </div>
                                    </div>
                                    <div v-else class="search-box" @click.stop>
                                        <input
                                            type="text"
                                            v-model="searchQuery"
                                            placeholder=""
                                            ref="searchInput"
                                        />
                                    </div>
                                    <i class="arrow" :class="{ open: isOpen }"></i>
                                </div>

                                <div v-if="isOpen" class="options-list" ref="optionsList">
                                    <div
                                        v-for="pdv in filteredPdvs"
                                        :key="pdv.id"
                                        class="option-item"
                                        @click.stop="selectPdv(pdv)"
                                    >
                                        <div class="pdv-name">
                                            {{ truncateText(pdv.name_pdv, 35) }}
                                        </div>
                                        <div class="pdv-address">
                                            <img src="/img-version2/icons/staff/location.svg" alt="location">
                                            {{ truncateText(pdv.address_pdv, 35) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 order-2 order-md-5">
                            <div class="d-flex justify-content-center mb-2">
                                <a href="#" class="text-decoration-none d-flex align-items-center gap-2" @click="modal_guide_status = true">
                                    <img src="/img-version2/icons/staff/book.svg" alt="arrow-right">
                                    <span class="text-more cursor-pointer text-decoration-underline">
                                        Guía de procesos de usuarios
                                    </span>
                                </a>
                            </div>
                        </div>
<!--                        <div class="col-12 col-md-6 col-lg-6 col-xl-6 order-4 order-md-1">-->
<!--                            <a v-if="admin_staff_segments.includes(client_segment)" href="#" @click="handleRedirect('transfer')" class="text-decoration-none">-->
<!--                                <button :disabled="isButtonDisabled" :class="{'btn-disabled-staff': isButtonDisabled, 'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"-->
<!--                                >Transferir usuario <img src="/img-version2/icons/staff/arrow-swap-horizontal.svg" alt="Icono"> </button>-->
<!--                            </a>-->
<!--                        </div>-->
                        <div
                            v-if="admin_staff_segments.includes(client_segment)"
                            class="col-12 staff-mobile-wrapper-buttons-new d-lg-none order-1 order-md-0 my-2"
                        >
                            <!-- Vincular usuario Staff -->
                            <a
                                href="#"
                                @click.prevent="handleRedirect('created')"
                                class="staff-mobile-item-buttons-new"
                            >
                                <button
                                    :disabled="isButtonDisabled"
                                    class="staff-card-buttons-new staff-card-primary"
                                    :class="{'btn-disabled-staff': isButtonDisabled, 'btn': true, 'rounded-3': true, 'p-2': true, 'px-3': true, 'text-bat': true, 'align-items-center': true, 'btnBlue': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                >
                                    <div class="staff-icon">
                                        <img src="/img-version2/icons/staff/vincular-staff.svg" alt="Vincular Staff">
                                    </div>
                                    <span class="staff-text">Vincular usuario Staff</span>
                                </button>
                            </a>

                            <!-- Solicitar / Transferir Staff -->
                            <a
                                href="#"
                                @click.prevent="handleRedirect('transfer')"
                                class="staff-mobile-item-buttons-new"
                            >
                                <button
                                    :disabled="isButtonDisabled"
                                    class="staff-card-buttons-new staff-card-outline"
                                    :class="{'btn-disabled-staff': isButtonDisabled, 'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true,  'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                >
                                    <div class="staff-icon">
                                        <img src="/img-version2/icons/staff/solicitar-staff.svg" alt="Transferir Staff">
                                    </div>
                                    <span class="staff-text">Solicitar Staff</span>
                                </button>
                            </a>
                        </div>
                        <div
                            v-if="admin_staff_segments.includes(client_segment)"
                            class="col-6 staff-mobile-wrapper-buttons-new three-buttons-staff d-lg-flex order-0 my-2"
                        >
                            <!-- Vincular usuario Staff -->
                            <a
                                href="#"
                                @click.prevent="handleRedirect('created')"
                                class="staff-mobile-item-buttons-new"
                            >
                                <button
                                    :disabled="isButtonDisabled"
                                    class="staff-card-buttons-new staff-card-primary"
                                    :class="{'btn-disabled-staff': isButtonDisabled, 'btn': true, 'rounded-3': true, 'p-2': true, 'px-3': true, 'text-bat': true, 'align-items-center': true, 'btnBlue': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                >
                                    <div class="staff-icon">
                                        <img src="/img-version2/icons/staff/vincular-staff.svg" alt="Vincular Staff">
                                    </div>
                                    <span class="staff-text">Vincular usuario Staff</span>
                                </button>
                            </a>

                            <!-- Solicitar / Transferir Staff -->
                            <a
                                href="#"
                                @click.prevent="handleRedirect('transfer')"
                                class="staff-mobile-item-buttons-new"
                            >
                                <button
                                    :disabled="isButtonDisabled"
                                    class="staff-card-buttons-new staff-card-outline"
                                    :class="{'btn-disabled-staff': isButtonDisabled, 'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true,  'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                >
                                    <div class="staff-icon">
                                        <img src="/img-version2/icons/staff/solicitar-staff.svg" alt="Transferir Staff">
                                    </div>
                                    <span class="staff-text">Solicitar Staff</span>
                                </button>
                            </a>
                            <a v-if="buttonTransfer"
                                href="#"
                                @click.prevent="handleRedirect('view_transfer')"
                                class="staff-mobile-item-buttons-new"
                            >
                                <button
                                    :disabled="isButtonDisabled"
                                    class="staff-card-buttons-new staff-card-outline"
                                    :class="{'btn-disabled-staff': isButtonDisabled, 'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true,  'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                >
                                    <div class="staff-icon">
                                        <img src="/img-version2/icons/staff/arrow-swap-horizontal-index.svg" alt="Transferir Staff">
                                    </div>
                                    <span class="staff-text">Ver trasferencias</span>
                                </button>
                            </a>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 col-xl-6 d-lg-none order-5 order-md-2">
                            <a v-if="admin_staff_segments.includes(client_segment) && buttonTransfer" href="#" @click="handleRedirect('view_transfer')" class="text-decoration-none">
                                <button :disabled="isButtonDisabled" :class="{'btn-disabled-staff': isButtonDisabled, 'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'mt-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                >Ver Transferencias <img src="/img-version2/icons/staff/arrow-swap-horizontal.svg" alt="Icono"></button>
                            </a>
                        </div>
                    </div>
                </div>

                <div v-if="paginatedData.length > 0" class="mt-2">
                    <div class="row justify-content-center p-1">
                        <div class="d-flex flex-wrap justify-content-start">
                            <div v-for="item in paginatedData" :key="item.id" class="col-lg-4 col-md-6 col-12 card-staff my-3 my-sm-1 px-3">
                                <div class="header">
                                    <div>
                                        <span :class="{'tag-success-staff': item.active && !('status' in item),
                                            'pending-status-staff': !('active' in item) && item.status === 'pending' ,
                                            'pending-status-for-active-staff': !('active' in item) && item.status === 'approved' ,
                                            'tag-disengagement-staff': item.status === 'disengagement' && item.active,
                                            'tag-inactive-user-staff': !item.active && !('status' in item)}">
                                        </span>
                                        <span>
                                            {{
                                                item.active && !('status' in item) ? 'Vinculado' :
                                                    (!item.active && !('status' in item) ? 'Inactivo' :
                                                        (!('active' in item) && item.status === 'pending' ? 'Vinculación en aprobación' :
                                                            (!('active' in item) && item.status === 'approved' ? 'Vinculación en proceso' :
                                                                (item.status === 'disengagement' && item.active ? 'Desvinculación en proceso' : ''))))
                                            }}
                                        </span>
                                    </div>
                                    <div v-if="item.status === 'disengagement'">
                                        <el-tooltip class="item" effect="light" placement="bottom">
                                            <div slot="content">No es posible cancelar<br/>una desvinculación pendiente.
                                            </div>
                                            <img src="/img-version2/icons/staff/InfoTooltip.svg" alt="arrow-right">
                                        </el-tooltip>
                                    </div>
                                    <div
                                        v-if="admin_staff_segments.includes(client_segment) && item.active && item.status !== 'disengagement'">
                                        <div v-show="[19,20].includes(item.segmentation_id)">
                                            <img v-if="item.is_champion" src="/img-version2/icons/staff/is_champion.svg"
                                                 alt="arrow-right" class="cursor-pointer" @click="modalRemove(item.id)">
                                            <img v-else src="/img-version2/icons/staff/is_not_champion.svg"
                                                 alt="arrow-right" class="cursor-pointer"
                                                 @click="champion.has_champion ? modalChampionAlreadyAssign = true : modalAssign(item.id)">
                                        </div>
                                    </div>
                                    <div
                                        v-if="!admin_staff_segments.includes(client_segment) && !admin_staff_segments.includes(item.segmentation_id) && item.is_champion">
                                        <img src="/img-version2/icons/staff/is_champion.svg" alt="arrow-right">
                                    </div>
                                    <div
                                        v-if="!item.active && !('status' in item)">
                                        <img class="cursor-pointer" src="/img-version2/icons/staff/user_inactive.svg" alt="arrow-right" @click="modalInactiveUser = true">
                                    </div>
                                </div>
                                <div class="content">
                                    <div class="mt-2 text-bat">
                                        <p class="name-h6 mb-2"><strong>{{ formatName(item.user?.name || item.name) }}</strong></p>
                                        <p v-if="item.status === 'approved' || item.status === 'pending' || item.status === 'disengagement'" class="name-h6 mb-2">Identificación: {{ item.identification_number || item.identificationNumber }}</p>

                                        <p v-if="item.status === 'pending' || item.status === 'disengagement'" class="name-h6 mb-2">Fecha de solicitud: {{ formatDate(item.created_at || item.createdAt) }}</p>
                                        <p v-else-if="item.status === 'approved'" class="name-h6 mb-2">Fecha de aprobación: {{ formatDate(item.updated_at || item.updatedAt) }}</p>

                                        <p v-if="item.request !== 'associate' && item.request !== 'new_user' && item.status !== 'disengagement'" class="name-h6 mb-2">Último Login: hace {{ daysSince(item.last_login) }} días</p>
                                        <p v-if="!item.active && !('status' in item)" class="name-h6 mb-2">Razón : <strong>{{ item.inactivate_reason }}</strong> </p>
                                        <p v-if="item.active && item.status !== 'approved' && item.status !== 'pending' && item.status !== 'disengagement'" class="name-h6 mb-2">Meta: <strong>{{ item.status_activity.total_activities }} Actividades</strong> </p>
                                        <p v-if="item.status !== 'approved' && item.status !== 'pending' && item.status !== 'disengagement'" class="name-h6 mb-2">Llevas: <strong>{{ item.status_activity.finished_activities }} Actividades</strong> </p>

                                        <p v-if="item.status === 'approved'" class="name-h6 mb-2"><strong>Tu usuario staff está pendiente de activación.</strong></p>
                                        <p v-if="item.status === 'disengagement'" class="name-h6 mb-2">Tu usuario staff <strong>será desvinculado próximamente</strong></p>

                                        <!-- progress -->
                                        <div v-if="item.status !== 'approved' && item.status !== 'pending' && item.status !== 'disengagement'" class="mb-1" >
                                            <div class="demo-progress">
                                                <el-progress :text-color="'#fff'" :percentage="item.status_activity.percentage" :color="customColorMethods(item.status_activity.percentage, item.active)" :stroke-width="20" :text-inside="true"></el-progress>
                                            </div>
                                        </div>
                                        <div v-if="item.status !== 'approved' && item.status !== 'pending' && item.status !== 'disengagement'" >
                                            <div class="row d-flex justify-content-between my-3">
                                                <div class="col-12 text-end resp-pts mb-1" style="font-size: 13px">
                                                    Puntos a perder:
                                                    <span class="py-1 px-2 rounded-1 mb-0  text-bat" :class="{'points' : item.active, 'points-inactive': !item.active}">
                                                        <b class="text-title-bat"> {{
                                                                item.points_activities.missing_points
                                                            }}</b> <small class="fw-bold"> Pts </small>
                                                    </span>
                                                </div>
                                                <div v-if="item.active && item.points_activities.limit_date !== ''" class="col-12 text-start">
                                                    <p>Tiene hasta el : <strong>{{ item.points_activities.limit_date }}</strong></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end text-decoration-underline">
                                    <a href="#" class="text-decoration-none" @click="openCancelRequestModal(item)" v-if="['pending', 'approved'].includes(item.status) && admin_staff_segments.includes(client_segment)">
                                        <span class="text-more cursor-pointer text-decoration-underline">
                                            Cancelar solicitud
                                        </span>
                                        <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                    </a>

                                    <a href="#" class="text-decoration-none" @click="goToClientDetails(item)" v-if="(item.active && item.status !== 'approved' && item.status !== 'pending') || (item.active && item.status === 'disengagement') || (!('status' in item) && !item.active)" :class="{'d-none': !shouldShowVerMas(item)}">
                                        <span class="text-more cursor-pointer text-decoration-underline">
                                            Ver más
                                        </span>
                                        <img src="/img-version2/icons/staff/arrow-right-blue.svg" alt="arrow-right">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center" v-if="totalPages > 1">
                        <div class="d-flex align-items-center justify-content-center">
                            <button @click="goToPage(currentPage - 1)" class="bg-transparent border-0" :disabled="currentPage === 1">
                                &lt;
                            </button>
                            <div class="text-bat">
                                <div v-if="visiblePages.length > 0">
                                    <span v-if="visiblePages[0] > 1">...</span>
                                    <span
                                        v-for="page in visiblePages"
                                        :key="page"
                                        @click="goToPage(page)"
                                        class="mx-3 mx-md-4 cursor-pointer"
                                        :class="{ 'text-title-bat text-orange': page === currentPage }">
                                        {{ page }}
                                    </span>
                                    <span v-if="visiblePages[visiblePages.length - 1] < totalPages">...</span>
                                </div>
                            </div>
                            <button @click="goToPage(currentPage + 1)" class="bg-transparent border-0"  :disabled="currentPage  === totalPages  || totalPages  === 0">
                                &gt;
                            </button>
                        </div>
                    </div>
                </div>

                <el-dialog :visible.sync="modal_guide_status" class="modal-status-request-staff"
                           :close-on-press-escape="true" :close-on-click-modal="true" :show-close="true">
                    <div class="row">
                        <div class="col-12">
                            <div class="glossary-container">
                                <div class="header-ranking">
                                    <div class="d-flex">
                                        <h5 class="text-title-bat text-black">Conoces los procesos</h5>
                                    </div>
                                    <h6 class="text-bat lh-base">
                                        Sigue de cerca el estado de los usuarios
                                    </h6>
                                </div>
                                <div class="grid-level text-bat py-2" style="background-color: #FBFBFB !important">
                                    <div class="px-1 mt-2">
                                        <h6 class="text-bat text-black lh-base">
                                            <strong>Estados del usuario</strong>
                                        </h6>
                                    </div>
                                    <div class="grid-item-level">
                                        <div class="card-status-request-staff px-2">
                                            <div class="header">
                                                <div>
                                                    <span class="tag-success-staff"></span>
                                                    <span>Vinculado</span>
                                                </div>
                                            </div>
                                            <div class="content">
                                                <div class="mt-1 text-bat">
                                                    <p class="name-h6 mb-0">Usuario staff vinculado y activo, podrá
                                                        acumular puntos y redimir.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-item-level">
                                        <div class="card-status-request-staff px-2">
                                            <div class="header">
                                                <div>
                                                    <span class="pending-status-staff"></span>
                                                    <span>Vinculación en aprobación</span>
                                                </div>
                                            </div>
                                            <div class="content">
                                                <div class="mt-1 text-bat">
                                                    <p class="name-h6 mb-0">Solicitud pendiente por aprobación.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-item-level">
                                        <div class="card-status-request-staff px-2">
                                            <div class="header">
                                                <div>
                                                    <span class="pending-status-for-active-staff"></span>
                                                    <span>Vinculación en proceso</span>
                                                </div>
                                            </div>
                                            <div class="content">
                                                <div class="mt-1 text-bat">
                                                    <p class="name-h6 mb-0">Tu usuario staff está pendiente de activación.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-item-level">

                                        <div class="card-status-request-staff px-2">
                                            <div class="header">
                                                <div>
                                                    <span class="tag-disengagement-staff"></span>
                                                    <span>Desvinculación en proceso</span>
                                                </div>
                                            </div>
                                            <div class="content">
                                                <div class="mt-1 text-bat">
                                                    <p class="name-h6 mb-0">Tu usuario staff será desvinculado próximamente</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-item-level">
                                        <div class="card-status-request-staff px-2">
                                            <div class="header">
                                                <div>
                                                    <span class="tag-inactive-user-staff"></span>
                                                    <span>Inactivo</span>
                                                </div>
                                                <div>
                                                    <img src="/img-version2/icons/staff/user_inactive.svg"
                                                         alt="arrow-right" class="modal-status-request-img">
                                                </div>
                                            </div>
                                            <div class="content">
                                                <div class="mt-1 text-bat">
                                                    <p class="name-h6 mb-0">No acumula puntos, ni suma a la meta general del equipo. Debes desvincular a este usuario para poder liberar el cupo de staff en el PDV.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid-level text-bat py-2" style="background-color: #FBFBFB !important">
                                    <div class="px-1 mt-2">
                                        <h6 class="text-bat text-black lh-base">
                                            <strong>Procesos del usuario</strong>
                                        </h6>
                                    </div>
                                    <div class="grid-item-level">
                                        <div class="card-status-request-staff px-2">
                                            <div class="header">
                                                <div>
                                                    <img src="/img-version2/icons/staff/add-circle.svg"
                                                         alt="arrow-right" class="modal-status-request-img">
                                                    <span>Vinculación</span>
                                                </div>
                                            </div>
                                            <div class="content">
                                                <div class="mt-1 text-bat">
                                                    <p class="name-h6 mb-0">Agregar un usuario nuevo o existente a un
                                                        PDV.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-item-level">
                                        <div class="card-status-request-staff px-2">
                                            <div class="header">
                                                <div>
                                                    <img src="/img-version2/icons/staff/minus-cirlce.svg"
                                                         alt="arrow-right" class="modal-status-request-img">
                                                    <span>Desvinculación</span>
                                                </div>
                                            </div>
                                            <div class="content">
                                                <div class="mt-1 text-bat">
                                                    <p class="name-h6 mb-0">Quitar un usuario de un PDV, perderá sus
                                                        puntos y no los podrá trasladar a otro usuario.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-item-level">
                                        <div class="card-status-request-staff px-2">
                                            <div class="header">
                                                <div>
                                                    <img src="/img-version2/icons/staff/arrow-swap-horizontal.svg"
                                                         alt="arrow-right" class="modal-status-request-img">
                                                    <span>Transferencia</span>
                                                </div>
                                            </div>
                                            <div class="content">
                                                <div class="mt-1 text-bat">
                                                    <p class="name-h6 mb-0">Solicitud pendiente por aprobación por parte del administrador del punto de venta.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>

        <el-dialog :visible.sync="modalCancelRequestUser" :width="getWidth()"
                   style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
                   :close-on-click-modal="true" :close-on-press-escape="true" :show-close="true">
            <div class="modals">
                <img src="/img-version2/icons/staff/user-remove.svg" alt="Icono">
                <h6 class="mx-auto" style="width: auto!important; max-width: 268px!important;">¿Estás seguro que deseas
                    cancelar la solicitud de este usuario?</h6>
            </div>
            <div class="d-flex align-items-center flex-column justify-content-center px-0">
                <div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="buttonTwo" type="buttoYes" @click="handleAction()">Si, continuar</div>
                    </div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="text-more cursor-pointer buttonOne" type="buttoNot" @click="modalCancelRequestUser = false">Cancelar</div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalAssignChampion" width="400px" class="filterDialogCatalog">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex flex-column align-items-center text-center">
                            <img src="/img-version2/icons/staff/dangerstaff.svg" alt="Icono" class="mb-2">
                            <h6 class="mx-auto" style="max-width: 268px;">Confirmar asignación de rol</h6>
                            <p class="text-bat px-0">Este usuario se convertirá en el champion del punto de venta
                                {{ pdv.name_pdv }}.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="d-flex flex-column align-items-center text-center">
                            <button
                                @click="assignChampion()"
                                :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'my-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                            >Continuar
                            </button>
                        </div>
                    </div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="d-flex flex-column align-items-center text-center">
                            <div class="text-more cursor-pointer buttonOne" type="buttoNot"
                                 @click="modalAssign()">Cancelar
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalRemoveChampion" width="400px" class="filterDialogCatalog">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex flex-column align-items-center text-center">
                            <img src="/img-version2/icons/staff/dangerstaff.svg" alt="Icono" class="mb-2">
                            <h6 class="mx-auto" style="max-width: 268px;">¿Estás seguro de
                                remover este rol?</h6>
                            <p class="text-bat px-0">Al hacerlo, otro usuario podrá tomar el rol de Champion en este PDV.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="d-flex flex-column align-items-center text-center">
                            <button
                                @click="removeChampion()"
                                :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'my-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                            >Remover Champion
                            </button>
                        </div>
                    </div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="d-flex flex-column align-items-center text-center">
                            <div class="text-more cursor-pointer buttonOne" type="buttoNot"
                                 @click="modalRemove()">Cancelar
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalChampionAlreadyAssign" width="400px" class="filterDialogCatalog">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex flex-column align-items-center text-center">
                            <img src="/img-version2/icons/staff/dangerstaff.svg" alt="Icono" class="mb-2">
                            <h6 class="mx-auto" style="max-width: 268px;">Este PDV ya tiene un champion asignado.</h6>
                            <p class="text-bat px-0">Para asignar uno nuevo, primero debes cambiar el actual. <br> Ve a la tarjeta de
                                <strong>{{ champion !== null && champion.has_champion ? champion.name : '' }}</strong> para hacerlo.</p>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalInactiveUser" width="400px" class="filterDialogCatalog">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex flex-column align-items-center text-center">
                            <img src="/img-version2/icons/staff/userInactiveBig.svg" alt="Icono" class="mb-2">
                            <h6 class="mx-auto" style="max-width: 268px;">Este usuario está inactivo</h6>
                            <p class="text-bat px-0">No acumula puntos, ni suma a la meta general del equipo. <br>
                                <strong>Importante: </strong> Si no lo desvinculas, seguirá asociado a un cupo del PDV.</p>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import {EventBus} from "../../app";

export default {
    props:{
        client_id:{
            default: null
        },
        pdv: {
            default: null
        },
        client_segment: {
            default: null,
        },
        admin_staff_segments: {
            default: [],
        },
    },
    data() {
        return {
            loading: 0,
            pdvs: [],
            selectedPdv: null,
            client: [],
            requests: [],
            requestsDisengagement: [],
            combinedData: null,
            modalCancelRequestUser: false,
            getWidth() {
                if (this.$mq === 'sm') {
                    return '95%';
                } else if (this.$mq === 'md') {
                    return '35%';
                } else if (this.$mq === 'lg') {
                    return '30%';
                } else {
                    return '20%';
                }
            },
            showAlert: false,
            currentPage: 1,
            itemsPerPage: 15,
            maxVisiblePages: 5,
            modal_guide_status:  false,
            modalAssignChampion: false,
            modalRemoveChampion: false,
            modalChampionAlreadyAssign: false,
            idChampion: null,
            champion: null,
            isOpen:false,
            searchQuery: "",
            modalInactiveUser: false,
            buttonTransfer: false,
        };
    },

    mounted() {
        this.selectedPdv = this.pdv.id;
        this.getActivePdvs();
        this.validateTransfers();
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    computed: {
        isButtonDisabled() {
            const selectedPdvData = this.pdvs.find(pdv => pdv.id === this.selectedPdv);
            return selectedPdvData && selectedPdvData.places <= (this.requests.length + this.client.length);
        },
        paginatedData() {
            if (!Array.isArray(this.combinedData)) {
                return [];
            }
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.combinedData.slice(start, end);
        },
        visiblePages() {
            const pages = [];
            const half = Math.floor(this.maxVisiblePages / 2);
            let start = Math.max(1, this.currentPage - half);
            let end = Math.min(this.totalPages, start + this.maxVisiblePages - 1);

            if (end - start < this.maxVisiblePages - 1) {
                start = Math.max(1, end - this.maxVisiblePages + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
        totalPages() {
            return Math.ceil(this.combinedData.length / this.itemsPerPage);
        },
        selectedPdvObj() {
            return this.pdvs.find(p => p.id === this.selectedPdv) || null
        },
        filteredPdvs() {
            if (!this.searchQuery) return this.pdvs;
            return this.pdvs.filter(pdv =>
                pdv.name_pdv.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                pdv.address_pdv.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
    },
    methods: {
        getActivePdvs() {
            axios.get('/get-active-pdvs')
                .then(({ data }) => {
                    this.pdvs = data.pdvs;
                    if (this.pdvs.length > 0) {
                        this.getRequestsForPdv();
                        this.getRequestsForDisengagementPdv();
                        this.getClientData();
                        this.loading = 1;
                    }
                })
                .catch(error => {
                    console.error("Error al obtener los PDVs activos", error);
                })
                .finally(() => {
                    this.loading = 0;
                });
        },
        getClientData() {
            if (!this.selectedPdv) return;
            axios.get(`/get-clients-pdv/${this.selectedPdv}`)
                .then(({ data }) => {
                    if (data.status === 'success' && data.clients.length > 0) {
                        this.champion = data.champion;
                        this.client = data.clients.map(client => client);
                    } else {
                        this.client = null;
                    }
                    this.validateRequestDisengagement();
                    this.checkPendingRequests();
                    this.loading = 1;
                })
                .catch(error => {
                    console.error("Error al obtener los datos del cliente", error);
                    this.client = null;
                })
                .finally(() => {
                    this.loading = 0;
                });
        },

        getRequestsForPdv() {
            if (!this.selectedPdv) return;
            axios.get(`/get-requests-pdv/${this.selectedPdv}`)
                .then(({ data }) => {
                    if (data.requestStaff && data.requestStaff.length > 0) {
                        this.requests = [...data.requestStaff];
                    } else {
                        this.requests = [];
                    }
                })
                .catch(error => {
                    console.error("Error al obtener las solicitudes del PDV", error);
                    this.requests = [];
                });
        },
        updateCombinedData() {
            this.combinedData = [
                ...this.client.map(client => ({
                    ...client,
                    isClient: true,
                    pivot: { client_id: client.id },

                })),

                ...this.requests.map(request => ({
                    ...request,
                    isClient: false,
                }))
            ];

        },
        checkPendingRequests() {
            const hasPendingRequests = this.combinedData.some(item => item.status === 'pending');

            if (hasPendingRequests) {
                this.showAlert = true;

                setTimeout(() => {
                    this.showAlert = false;
                }, 10000);
            }
        },

        formatDate(date) {
            const d = new Date(date);
            return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
        },
        openCancelRequestModal(item) {
            this.selectedItem = item;
            this.modalCancelRequestUser = true;
        },
        handleAction() {
            if (this.selectedItem && this.selectedItem.request === 'new_user') {
                this.cancelRequest(
                    this.selectedItem.identification_number || this.selectedItem.identificationNumber,
                    this.selectedPdv
                );
            }
            this.modalCancelRequestUser = false;
            window.location.reload();
        },

        cancelRequest(identificationNumber, selectedPdv) {
            axios.post(`/cancel-request-pdv/${this.selectedPdv}`, {
                identification_number: identificationNumber
            })
                .then(response => {
                })
                .catch(error => {
                    console.error("Error al cancelar la solicitud", error.response ? error.response.data : error);
                });
        },
        isClientInCombinedData() {
            return this.combinedData.some(data => data.id === this.client?.id);
        },
        goToClientDetails(item) {
            this.loading = 1;
            const clientId = item.id;
            window.location.href = `/get-client-pdv-details/${this.selectedPdv}/${clientId}`;
        },
        shouldShowVerMas(item) {
            return item.pivot.client_id !== this.client_id;
        },
        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        },
        handleRedirect(type = 'created') {
            if(type === 'created'){
                if (this.pdv.places !== this.combinedData.length) {
                    window.location.href = `/create-request-staff/${this.selectedPdv}`;
                }
            }
            if(type === 'transfer'){
                window.location.href = `/transfer-user/arrived/${this.selectedPdv}`;
            }
            if(type === 'view_transfer'){
                window.location.href = `/staff-transfers/${this.selectedPdv}`;
            }


        },
        customColorMethods(percentage, status) {
            if(status){
                if (percentage >= 100) {
                    return 'green';
                } else if (percentage >= 90 && percentage < 100) {
                    return 'orange';
                } else {
                    return 'red';
                }
            }else{
                return '#C1C1C1';
            }
        },
        changeSelectedPDV(pdvId) {
            this.loading++;

            axios.post('/change-selected-pdv', { pdv_id: pdvId })
                 .then(response => {
                     history.replaceState({}, null, `/get-pdv-details/${pdvId}`);
                     EventBus.$emit('change-select-pdv', { select_pdv: pdvId });
                     this.getClientData();
                 })
                 .catch(error => {
                     console.error('Error al cambiar el PDV seleccionado:', error);
                     this.loading--;
                 });
        },
        daysSince(date) {
            const updatedDate = new Date(date);
            const today = new Date();
            const diffTime = today - updatedDate;
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            return diffDays;
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        getRequestsForDisengagementPdv() {
            if (!this.selectedPdv) return;
            axios.get(`/get-requests-disengagement-pdv/${this.selectedPdv}`)
                .then(({ data }) => {
                    if (data.requestStaff && data.requestStaff.length > 0) {
                        this.requestsDisengagement = [...data.requestStaff];
                    } else {
                        this.requestsDisengagement = [];
                    }
                })
                .catch(error => {
                    console.error("Error al obtener las solicitudes de desvinculación del PDV", error);
                    this.requestsDisengagement = [];
                });

        },
        validateRequestDisengagement() {
            this.client = this.client.map(item => {
                const matchedRequest = this.requestsDisengagement.find(
                    req => req.identification_number === item.identification_number
                );
                if (matchedRequest) {
                    return {
                        ...item,
                        status: 'disengagement',
                        active: 1,
                        created_at: matchedRequest.created_at
                    };
                }
                return item;
            });
            this.updateCombinedData();
        },
        modalRemove(id){
            this.modalRemoveChampion = !this.modalRemoveChampion;
            if(!this.modalRemoveChampion){
                this.idChampion = null;
            }else{
                this.idChampion = id;
            }
        },
        modalAssign(id){
            this.modalAssignChampion = !this.modalAssignChampion;
            if(!this.modalAssignChampion){
                this.idChampion = null;
            }else{
                this.idChampion = id;
            }
        },
        assignChampion(){
            if(this.idChampion === null){ console.error("Error al asignar champion"); }
            axios.post(`/set-champion/${this.selectedPdv}`, {
                client_id: this.idChampion
            })
                .then(response => {
                    if (response.status === 200 ) {
                        this.modalAssignChampion = false;
                        this.getClientData();
                    }
                })
                .catch(error => {
                    console.error("Error al asignar champion", error);
                });
        },
        removeChampion(){
            if(this.idChampion === null){ console.error("Error al remover champion"); }
            axios.post(`/unset-champion/${this.selectedPdv}`, {
                client_id: this.idChampion
            })
                .then(response => {
                    if (response.status === 200 ) {
                        this.modalRemoveChampion = false;
                        this.getClientData();
                    }
                })
                .catch(error => {
                    console.error("Error al remover champion", error);
                });
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen
            if (this.isOpen) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            } else {
                this.searchQuery = "";
            }
        },
        selectPdv(pdv) {
            this.selectedPdv = pdv.id
            this.isOpen = false
            this.searchQuery = "";
            this.combinedData = null;
            this.changeSelectedPDV(pdv.id);
            this.validateTransfers();
        },
        truncateText(text, maxLength) {
            if (!text) return 'Sin Dirección'
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
        },
        handleClickOutside(event) {
            const clickInside = this.$refs.customSelect.contains(event.target) ||
                (this.$refs.optionsList && this.$refs.optionsList.contains(event.target));
            if (!clickInside) {
                this.isOpen = false;
                this.searchQuery = "";
            }
        },
        validateTransfers(){
            Promise.all([
                axios.get(`/get-my-requests-transfer?insitu_code=${this.pdv.insitu_code}`),
                axios.get(`/get-request-transfer-to-me?insitu_code=${this.pdv.insitu_code}`)
            ])
                .then(([res1, res2]) => {
                    const request = res1.data.requests ?? [];
                    const my_request = res1.data.my_requests ?? [];

                    const request_to_me = res2.data.requests ?? [];
                    const my_request_to_me = res2.data.requests_to_me ?? [];

                    const total =
                        request.length +
                        my_request.length +
                        request_to_me.length +
                        my_request_to_me.length;

                    this.buttonTransfer = total > 0;
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
};
</script>
